import { lazy } from 'react';

export default lazy(() =>
  import(/* webpackChunkName: 'discover_page' */ './Discover'),
);
